
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactGA from "react-ga4";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Milestone } from "./components/Milestone";
import { ReadyMadeSoftware } from "./components/ReadyMadeSoftware";
import { AzmaHealthBudget } from "./components/clients/AzmaHealthBudget";
import { Boimela } from "./components/clients/Boimela";
import { SolutionProvider } from "./components/clients/SolutionProvider";

function App() {
  return (
    <HashRouter>
      <RouteChangeTracker />
      <div className="App">
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/skills" element={<HomePage />} />
          <Route path="/projects" element={<HomePage />} />
          <Route path="/connect" element={<HomePage />} />
          <Route path="/ready-made" element={<HomePage />} />
          <Route path="/analytics-test" element={<AnalyticsTest />} />
          <Route path="/azma-health-budget" element={<AzmaHealthBudget />} />
          <Route path="/boimela" element={<Boimela />} />
          <Route path="/solution-provider" element={<SolutionProvider />} />
        </Routes>
        <Footer />
      </div>
    </HashRouter>
  );
}

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: `${location.pathname}${location.search}`,
      title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionMap = {
      "/home": "home",
      "/skills": "skills",
      "/projects": "projects",
      "/connect": "connect",
      "/ready-made": "ready-made",
    };

    const targetId = sectionMap[location.pathname];
    if (!targetId) {
      return;
    }

    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.pathname]);

  return (
    <>
      <Banner />
      <Milestone />
      <Skills />
      <Projects />
      <ReadyMadeSoftware />
      <Contact />
    </>
  );
};

const AnalyticsTest = () => {
  return (
    <section className="container py-5">
      <h1 className="mb-3">Analytics Test</h1>
      <p>Open GA4 Realtime to verify pageviews for this route.</p>
    </section>
  );
};

export default App;